import { createClient } from "@supabase/supabase-js";

// No hardcoded fallback: a missing env var must NOT silently point at prod.
// Local dev sets these to the local Supabase (http://127.0.0.1:54321) in .env;
// qa/prod set them in their respective env files. Fail loud if unset so we can
// never accidentally read/write the wrong Supabase project.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
	throw new Error(
		"Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. " +
			"Set them in your environment (local dev uses http://127.0.0.1:54321). " +
			"Refusing to start without an explicit Supabase target."
	);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	auth: {
		persistSession: false
	}
});

// Make the active target obvious during development so a mis-set env is caught
// immediately instead of silently reading/writing the wrong project.
if (process.env.NODE_ENV !== "production") {
	// eslint-disable-next-line no-console
	console.warn(`[dev] Supabase target: ${supabaseUrl}`);
}

export default supabase;
